import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions } from "vuex";
import loader from "../modals/loader";
export default {
  data: function data() {
    return {
      sent: false,
      response: ''
    };
  },

  components: {
    loader: loader
  },
  // async mounted() {
  //   try {
  //     console.log('Entra acaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
  //     const res = await this.$store.dispatch("affiliations/form/addCommerceCodeFile", {});
  //     this.response = res
  //   } catch (error) {
  //     console.log('Error...', error)
  //   }
  // },
  methods: _extends({}, mapMutations({
    setLeaveToDashboard: "dashboard/details/setLeaveToDashboard",
    emptyData: "affiliations/form/emptyData"
  }), mapActions({
    downloadAffiliationToPrint: "affiliations/form/downloadAffiliationToPrint"
  }), {
    returnDashboard: function returnDashboard() {
      this.setLeaveToDashboard(true);
      this.$store.commit('affiliations/form/finishAffiliation', 1);
      this.$nextTick(function () {
        this.emptyData();
        this.$router.push("/dashboard");
      });
    }
  }),
  computed: _extends({}, mapState({
    commerceCode: function commerceCode(state) {
      return state.affiliations.form.commerceCode;
    },
    applyToCodeQR: function applyToCodeQR(state) {
      return state.affiliations.form.applyToCodeQR;
    },
    isVirtual: function isVirtual(state) {
      return state.affiliations.form.productType === '2';
    }
  }))
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/terms.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/terms.vue
// module chunks = 0 1 2 3